import {transportCategory, TransportCategory} from "../transport-category";
import {Exclude, Expose} from "class-transformer";

export interface InventoryCategoryStatistics {
    volume: Record<number, number>
}

@Exclude()
export class InventoryCategoryStatisticsWrapper implements InventoryCategoryStatistics {
    @Expose()
    volume: Record<number, number> = {}
}

export interface InventoryStatistics {
    water: InventoryCategoryStatistics
    oil: InventoryCategoryStatistics
    other: InventoryCategoryStatistics
}

@Exclude()
export class InventoryStatisticsWrapper implements InventoryStatistics {
    @Expose()
    water = new InventoryCategoryStatisticsWrapper()

    @Expose()
    oil = new InventoryCategoryStatisticsWrapper()

    @Expose()
    other = new InventoryCategoryStatisticsWrapper()

    getCategoryStats(category: TransportCategory): InventoryCategoryStatisticsWrapper | undefined {
        let pipelineCategoryStats: InventoryCategoryStatisticsWrapper | undefined = undefined

        if (category === transportCategory.water) {
            pipelineCategoryStats = this.water
        } else if (category === transportCategory.oil) {
            pipelineCategoryStats = this.oil
        }

        return pipelineCategoryStats
    }

    private getCategoryStatsList(category: TransportCategory | undefined = undefined): InventoryCategoryStatisticsWrapper[] {
        const categoryStatsList: InventoryCategoryStatisticsWrapper[] = []

        if (category) {
            const categoryStats = this.getCategoryStats(category)
            if (categoryStats) {
                categoryStatsList.push(categoryStats)
            }
        } else {
            categoryStatsList.push(this.water, this.oil, this.other)
        }

        return categoryStatsList
    }

    private sum(categoryStatsList: InventoryCategoryStatisticsWrapper[], mapper: (categoryStats: InventoryCategoryStatisticsWrapper) => number): number {
        let value = 0

        for (const categoryStats of categoryStatsList) {
            value += mapper(categoryStats)
        }

        return value
    }

    getVolume(dttm: number, category: TransportCategory | undefined = undefined): number {
        const categoryStatsList: InventoryCategoryStatisticsWrapper[] = this.getCategoryStatsList(category)
        return this.sum(categoryStatsList, (stats) => stats.volume[dttm] ?? 0)
    }

    getTotalVolume(category: TransportCategory | undefined = undefined): number {
        const categoryStatsList: InventoryCategoryStatisticsWrapper[] = this.getCategoryStatsList(category)
        return this.sum(categoryStatsList, (stats) => Object.values(stats.volume).reduce((a, b) => a + b, 0));
    }
}
